import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { getTranslate } from '../../../utils/getTranslate/getTranslate';
import { getRandomArray } from '../../../utils/getRandomArray/getRandomArray';
import { getRandomMax } from '../../../utils/getRandomMax/getRandomMax';
import { getRandomRange } from '../../../utils/getRandomRange/getRandomRange';
import { getRandomRangeArray } from '../../../utils/getRandomRangeArray/getRandomRangeArray';

import Lightbox from 'yet-another-react-lightbox';

import color from '../../../data/color/color.json';

import styles from '../Museum.module.scss';

export const Hall = ({ upPage }) => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const t = getTranslate;
  const { lang } = useParams();
  const { toptitle, title, text, items } = upPage.acf.hall;
  const upRandomArray = getRandomArray(color.length, items.length);
  const upRanArr = getRandomRangeArray(4, 7, items.length);
  const slides = items.map((el) => ({ src: el.img_link }));

  return (
    <section className={styles.hall}>
      <div className="container">
        <div className={styles.hall_body}>
          <h3 className={`${styles.hall_subtitle} global-subtitle`}>{toptitle[lang]}</h3>
          <h2 className={`${styles.hall_title} global-title`}>{title[lang]}</h2>
          <p className={`${styles.hall_text} global-text`}>{text[lang]}</p>
          <div className={styles.hall_row}>
            {items.map((el, idx) => {
              const { img, icon, title, text } = el;
              return (
                <div key={idx} className={styles.hall_column}>
                  <div
                    className={styles.hall_column_body}
                    style={{ borderTop: `4px solid ${color[upRandomArray[idx]]}` }}
                    onClick={() => {
                      setIndex(idx);
                      setOpen(true);
                    }}
                  >
                    {!!img ? (
                      <div
                        className={styles.hall_column_img}
                        style={{
                          animation: `${styles.bounce} ${upRanArr[idx]}s ease-in-out infinite`,
                        }}
                      >
                        <img src={img} alt="hall" />
                      </div>
                    ) : (
                      <div
                        className={styles.hall_column_icon}
                        style={{
                          animation: `${styles.bounce} ${upRanArr[idx]}s ease-in-out infinite`,
                        }}
                      >
                        {icon}
                      </div>
                    )}
                    <p className={styles.hall_column_toptitle} style={{ color: color[upRandomArray[idx]] }}>
                      {t(`${idx + 1} бөлім`, `Зал ${idx + 1}`, lang)}
                    </p>
                    <h4 className={styles.hall_column_title}>{title[lang]}</h4>
                    <p className={`${styles.hall_column_text} global-text`}>{text[lang]}</p>
                  </div>
                </div>
              );
            })}
          </div>
          <Lightbox
            open={open}
            close={() => setOpen(false)}
            index={0}
            slides={open ? [slides[index]] : []}
            render={{
              buttonPrev: () => null,
              buttonNext: () => null,
            }}
            carousel={{
              draggable: false,
              swipeable: false,
              finite: true,
            }}
          />
        </div>
      </div>
    </section>
  );
};
